"use client";

import { useSocketContext } from "@/providers/socket-provider";

export const useSocket = () => useSocketContext();
